import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { Cultura } from 'src/app/classes/Cultura';
import { enumErpIntegrado } from 'src/app/classes/Empresa';
import { GrupoProduto } from 'src/app/classes/GrupoProduto';
import { GrupoProdutoCulturaCentroCusto } from 'src/app/classes/GrupoProdutoCulturaCentroCusto';
import { GrupoProdutoService } from 'src/app/services/grupo-produto.service';
import { PlanejamentoService } from 'src/app/services/planejamento.service';
import { StorageService } from 'src/app/services/storage.service';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { UtilsService } from 'src/app/utils/utils.service';
import Swal from 'sweetalert2';
import { ColumnModel, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { SyncGridComponent } from '../../shared-farm/sync-grid/sync-grid.component';
import { finalize } from 'rxjs/operators';
import { GrupoProdutoFormsComponent } from './grupo-produto-forms/grupo-produto-forms.component';
import * as moment from 'moment';

@Component({
  selector: 'app-grupo-produto',
  templateUrl: './grupo-produto.component.html',
  styleUrls: ['./grupo-produto.component.scss']
})
export class GrupoProdutoComponent implements OnInit {

  @Input() IsNovo: boolean = false;
  @Input() IsServico: boolean = false;

  @ViewChild("gridGruposProduto", { static: false })
  gridGruposProduto: SyncGridComponent;

  @ViewChild("FormsGrupoProduto", { static: false })
  formsGrupoProduto: GrupoProdutoFormsComponent;

  gruposProduto: GrupoProduto[] = [];
  auxGruposProduto: GrupoProduto[];
  id: number = 0;
  inserindo: boolean = false;
  carregando: boolean = false;
  servicos: boolean = false;

  textoBusca: string = "";

  listaGrupoProdutoCulturaCentroCusto: GrupoProdutoCulturaCentroCusto[] = [];
  culturas: Cultura[] = [];
  integraTotvs: boolean = false;

  grupoProdutoColumns: ColumnModel[] = [];
  desabilitarAcoes: boolean = false;
  removendo: boolean = false;
  duplicando: boolean = false;
  inativando: boolean = false;
  gridHeight: string = '79vh';

  pageSettings?: PageSettingsModel = {
    pageSizes: [10, 20, 30, 40, 50, 100],
    pageSize: 20,
    pageCount: 4,
  };

  // tradução
  GRUPO_DE_SERVICO_ALTERADO: string = 'Grupo de Serviço alterado!';
  GRUPO_DE_PRODUTO_ALTERADO: string = 'Grupo de Produto alterado!';
  FEITO: string = 'Feito!';
  ERRO: string = "Erro!";
  GRUPO_DE_SERVICO_CADASTRO: string = 'Grupo de Serviço cadastro!';
  GRUPO_DE_PRODUTO_CADASTRO: string = 'Grupo de Produto cadastro!';
  DELETAR: string = 'Deletar';
  SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA: string = 'Se deletar, esta ação não poderá ser desfeita!';
  CONFIRMAR_DELETE: string = "Se deletar, esta ação não poderá ser desfeita!";
  CANCELAR: string = 'Cancelar';
  SIM: string = 'Sim';
  GRUPO_DE_SERVICO_DELETADO: string = 'Grupo de Serviço deletado!';
  GRUPO_DE_PRODUTO_DELETADO: string = 'Grupo de Produto deletado!';


  configurarTraducao() {
    this.GRUPO_DE_SERVICO_ALTERADO = this.translate.instant('GRUPO_DE_SERVICO_ALTERADO');
    this.GRUPO_DE_PRODUTO_ALTERADO = this.translate.instant('GRUPO_DE_PRODUTO_ALTERADO');
    this.FEITO = this.translate.instant('FEITO');
    this.ERRO = this.translate.instant("ERRO");
    this.GRUPO_DE_SERVICO_CADASTRO = this.translate.instant('GRUPO_DE_SERVICO_CADASTRO');
    this.GRUPO_DE_PRODUTO_CADASTRO = this.translate.instant('GRUPO_DE_PRODUTO_CADASTRO');
    this.DELETAR = this.translate.instant('DELETAR');
    this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA = this.translate.instant('SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA');
    this.CONFIRMAR_DELETE = this.translate.instant("CONFIRMAR_DELETE");
    this.CANCELAR = this.translate.instant('CANCELAR');
    this.SIM = this.translate.instant('SIM');
    this.GRUPO_DE_SERVICO_DELETADO = this.translate.instant('GRUPO_DE_SERVICO_DELETADO');
    this.GRUPO_DE_PRODUTO_DELETADO = this.translate.instant('GRUPO_DE_PRODUTO_DELETADO');
  }

  constructor(
    private gruposProdutoService: GrupoProdutoService,
    private route: ActivatedRoute,
    private router: Router,
    private utils: UtilsService,
    private translate: TranslateService,
    private storageService: StorageService,
    private toasty: CustomToastyService,
    private planejamentoService: PlanejamentoService,
    private location: Location
  ) {
    if (this.router.url.search("inserir") > 0) {
      if (!this.utils.verificarPermissaoUsuario('IncluirGrupoProduto')) {
        this.location.back();
      }
    }

    this.route.params.subscribe(res => {
      this.id = res.id;
      if (res.id && res.id > 0 && this.router.url.search("inserir") < 0) {
        if (!this.utils.verificarPermissaoUsuario('EditarGrupoProduto')) {
          this.location.back();
        }
      }
    });
    this.servicos = this.router.url.includes('grupo-servico');
  }

  ngOnInit() {
    this.inserindo = this.router.url.search("inserir") > 0;
    if (this.IsNovo) {
      this.inserindo = true;
      if (this.IsServico) {
        this.servicos = true;
      }
    }
    this.integraTotvs = this.storageService.getEmpresa().ErpIntegrado == enumErpIntegrado.Totvs_RM;
    this.planejamentoService.getCulturas().subscribe(ret => {
      this.culturas = ret;
      this.carregando = false;
    });
    if (!this.inserindo && !this.id) {
      this.listarGruposProduto();
      this.configurarGrid();
    }
    
    this.configurarTraducao();
  }

  ajustarTamanhoGrid(): void {
    const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement
    const groupdroparea = document.querySelector('div.e-groupdroparea.e-lib.e-droppable.e-draggable') as HTMLElement
    const toolbar = document.querySelector('div.custom-toolbar.justify-content-between') as HTMLElement
    const title = document.querySelector('app-grupo-produto h5.titulo') as HTMLElement
    const pager = document.querySelector('div.e-gridpager.e-control.e-pager.e-lib') as HTMLElement
    if (navbar && groupdroparea && toolbar && title && pager) {
      const altura = window.innerHeight - navbar.offsetHeight - groupdroparea.offsetHeight - toolbar.offsetHeight - title.offsetHeight - pager.offsetHeight - 70
      this.gridHeight = `${altura}px`
    }
  }

  configurarGrid(): void {
    if (window.innerHeight <= 1000) this.pageSettings.pageSize = 20;
    else this.pageSettings.pageSize = 40

    this.grupoProdutoColumns = [
      { type: "checkbox", width: 50, showInColumnChooser: false },
      {
        field: "Descricao",
        type: "string",
        headerText: this.servicos ? "Grupo de Serviço" : "Grupo de Produto",
        allowSorting: true,
      },
      {
        field: "IdERP",
        headerText: "ID ERP",
        type: "string",
        allowSorting: true,
      },
      {
        field: "dataAlteracaoStr",
        type: "string",
        headerText: "Ult. Mod.",
        allowSorting: true,
        sortComparer: (a: string, b: string) => {
          const dateA = moment(a, 'DD/MM/YYYY HH:mm');
          const dateB = moment(b, 'DD/MM/YYYY HH:mm');
          return dateA.diff(dateB);
        },
      },
      {
        field: "UsuarioAlteracaoDesc",
        headerText: "Resp. Mod.",
        type: "string",
        allowSorting: true,
      },
      {
        field: "descAtivo",
        headerText: "Status",
        allowSorting: true,
        disableHtmlEncode: false,
        type: 'boolean',
        valueAccessor: (_field: string, _data: any): any => {
          return this.badgeStatusUsuario(_data.Ativo);
        }
      } as ColumnModel,
    ];
    setTimeout(() => this.ajustarTamanhoGrid(), 100);
  }

  doubleClick(event): void {
    this.editar(event)
  }

  badgeStatusUsuario(ativo: boolean): string {
    return ativo ? '<span class="badge badge-light-success custom-badge-grid">Ativo</span>' : '<span class="badge badge-light-danger custom-badge-grid">Inativo</span>'
  }

  listarGruposProduto() {
    this.carregando = true;
    const serviceCall = this.servicos
      ? this.gruposProdutoService.listarTodosServicos()
      : this.gruposProdutoService.listarTodosProdutos();

    serviceCall
      .pipe(
        finalize(() => {
          this.carregando = false;
        })
      )
      .subscribe(
        res => {
          this.gruposProduto = res.map(u => Object.assign(new GrupoProduto(), u));
          if (!this.inserindo)
            this.auxGruposProduto = res;
          if (this.textoBusca != '')
            this.filtrarGruposProduto();
        },
        err => {
          this.utils.getErro(err);
        }
      );
  }

  novo(): void {
    if (!this.utils.verificarPermissaoUsuario('IncluirGrupoProduto'))
      return;

    this.formsGrupoProduto.abrirModal();
  }

  editar(grupoProduto: GrupoProduto): void {
    let grupo;
    if (!grupoProduto) {
      var grupos = this.gridGruposProduto.getSelectedRecords();
      if (!this.ValidarSelectApenasUm()) return;

      grupo = { ...grupos[0] };
    }
    else
      grupo = { ...grupoProduto }

    if (!this.utils.verificarPermissaoUsuario('EditarGrupoProduto'))
      return;

    this.formsGrupoProduto.abrirModal(grupo);
  }

  ValidarSelectApenasUm(): boolean {
    var grupos = this.gridGruposProduto.getSelectedRecords();
    if (grupos.length == 0) {
      this.utils.handleWarning("Selecione um item para continuar");
      return false;
    }
    if (grupos.length > 1) {
      this.utils.handleWarning("Selecione apenas um item para continuar");
      return false;
    }
    return true;
  }

  ValidarSelectUmOuMais(): boolean {
    var grupos = this.gridGruposProduto.getSelectedRecords();
    if (grupos.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return false;
    }
    return true;
  }

  finalizarSaveGrupoProduto(): void {
    this.listarGruposProduto();
  }

  confirmaDuplicar(): void {
    var grupos = this.gridGruposProduto.getSelectedRecords();
    if (!this.ValidarSelectUmOuMais()) return
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: `Os grupos selecionados serão duplicados!`,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Duplicar grupos",
    }).then((response) => {
      if (!response.dismiss) {
        this.duplicar(grupos);
      }
    });
  }

  duplicar(grupos: GrupoProduto[]): void {
    this.duplicando = true
    this.gruposProdutoService.duplicar(grupos.map(p => p.Id))
      .subscribe(() => {
        this.utils.handleSuccess(this.servicos ? "Grupos de Serviço duplicados com sucesso" : "Grupos de Produto duplicados com sucesso")
        this.listarGruposProduto();
        this.duplicando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.duplicando = false
        }
      )
  }

  confirmaInativar(): void {
    if (!this.ValidarSelectUmOuMais()) return
    const grupos = this.gridGruposProduto.getSelectedRecords() as GrupoProduto[];
    if (grupos.length === 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }

    const todosInativos = grupos.every(grupo => grupo.Ativo === false);
    const algumaInativa = grupos.some(grupo => grupo.Ativo === false);

    if (todosInativos) {
      this.utils.handleWarning(this.servicos
        ? "Todos os grupos de serviço selecionados já estão inativos"
        : "Todos os grupos de produto selecionados já estão inativos");
      return;
    }

    let texto = this.servicos
      ? "Os grupos de serviço selecionados serão inativados!"
      : "Os grupos de produto selecionados serão inativados!";

    if (algumaInativa) {
      texto += '<br> Alguns grupos já estão inativos e serão ignorados.';
    }

    Swal.fire({
      title: "Você tem certeza desta ação?",
      html: texto,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: this.servicos ? "Inativar grupos de serviço" : "Inativar grupos de produto",
    }).then((response) => {
      if (!response.dismiss) {
        const ativos = grupos.filter(grupo => grupo.Ativo === true);
        if (ativos.length === 0) {
          this.utils.handleWarning(this.servicos
            ? "Todos os grupos de serviço selecionados já estão inativos"
            : "Todos os grupos de produto selecionados já estão inativos");
          return;
        }
        this.inativar(grupos);
      }
    });
  }

  inativar(grupos: GrupoProduto[]): void {
    this.inativando = true
    this.gruposProdutoService.inativar(grupos.map(p => p.Id))
      .subscribe((res) => {
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const item = grupos.find(v => v.Id.toString() === id);
            const nomeItem = item ? item.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeItem}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao Inativar Grupos de Produto',
            html: `Os seguintes grupos de produtos não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } if (grupos.filter(v => v.Ativo === false).length > 0) {
          const erros: string[] = [];
          grupos.filter(v => v.Ativo === false).forEach(item => {
            const nomeItem = item ? item.Descricao : `ID ${item.Id}`;
            erros.push(`<b>${nomeItem}</b>: Já está inativo.`);
          });
          Swal.fire({
            title: 'Erro ao Inativar Grupos de Produto',
            html: `os seguintes grupo de produto não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        }
        else {
          this.utils.handleSuccess("Grupos de produtos inativados com sucesso");
        } this.listarGruposProduto();
        this.inativando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.inativando = false
        }
      )
  }

  confirmRemover() {
    if (!this.utils.verificarPermissaoUsuario('ExcluirGrupoProduto'))
      return;

    this.ERRO = this.translate.instant("ERRO");
    this.FEITO = this.translate.instant("FEITO");
    this.CONFIRMAR_DELETE = this.translate.instant("CONFIRMAR_DELETE");
    this.CANCELAR = this.translate.instant("CANCELAR");
    this.SIM = this.translate.instant("SIM");
    this.GRUPO_DE_SERVICO_DELETADO = this.translate.instant("GRUPO_DE_SERVICO_DELETADO");
    this.GRUPO_DE_PRODUTO_DELETADO = this.translate.instant("GRUPO_DE_PRODUTO_DELETADO");

    var grupos = this.gridGruposProduto.getSelectedRecords();
    if (grupos.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: `Os grupos selecionados serão excluídos, esta ação não poderá ser desfeita!`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (!willDelete.dismiss)
        this.removerGruposProduto(grupos)
    });
  }

  removerGruposProduto(grupos: GrupoProduto[]) {
    this.removendo = true;
    this.gruposProdutoService.deleteGruposProduto(grupos.map(p => p.Id)).subscribe(
      res => {
        console.debug('res: ', res)

        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais grupos falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const grupo = grupos.find(g => g.Id.toString() === id);
            const nomeGrupo = grupo ? grupo.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeGrupo}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao excluir grupos',
            html: `Os seguintes grupos não puderam ser excluídos:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          // Sucesso - todos os grupos foram excluídos
          this.utils.handleSuccess(this.servicos ? "Grupos de Serviço excluídos com sucesso" : "Grupos de Produto excluídos com sucesso");
        }

        this.listarGruposProduto();
        this.removendo = false;
      },
      err => {
        this.utils.getErro(err);
        this.removendo = false;
      });
  }

  filtrarGruposProduto() {
    this.gruposProduto = this.auxGruposProduto.filter(x =>
      x.Descricao.toUpperCase().includes(this.textoBusca.toUpperCase()) ||
      x.Id.toString().includes(this.textoBusca.toUpperCase())
    );
  }

  cancelar(isServico: boolean) {
    if (isServico)
      this.router.navigate(['/cadastros/grupo-servico']);
    else
      this.router.navigate(['/estoques/grupo-produto']);
  }

}
